'use strict';

const clone = require('lodash/clone');
const isString = require('lodash/isString');

const moment = require('moment-timezone/builds/moment-timezone.min.js');

moment.tz.add([
    'Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5',
]);

function wrappedMoment(dateString) {
    if (dateString) {
        return moment.tz(dateString, 'Australia/Melbourne');
    }

    return moment.tz('Australia/Melbourne');
}

function format(dateString, dateFormat) {
    if (dateFormat) {
        return wrappedMoment(dateString).format(dateFormat);
    }

    return wrappedMoment(dateString).format();
}

function pretty(startDate, endDate) {
    let startDateClone = clone(startDate);
    let endDateClone = clone(endDate);

    if (isString(startDateClone)) {
        startDateClone = wrappedMoment(startDateClone);
    }

    if (isString(endDateClone)) {
        endDateClone = wrappedMoment(endDateClone);
    }

    if (startDateClone.format('YYYY-MM-DD') === endDateClone.format('YYYY-MM-DD')) {
        return startDateClone.format('ddd D MMMM');
    }

    if (startDateClone.format('YYYY-MM') === endDateClone.format('YYYY-MM')) {
        return startDateClone.format('ddd D') + ' – ' + endDateClone.format('ddd D MMMM');
    }

    if (startDateClone.format('YYYY') === endDateClone.format('YYYY')) {
        return startDateClone.format('ddd D MMMM') + ' – ' + endDateClone.format('ddd D MMMM');
    }

    return startDateClone.format('ddd D MMMM YYYY') + ' – ' + endDateClone.format('ddd D MMMM YYYY');
}

module.exports = {
    moment: wrappedMoment,
    format: format,
    pretty: pretty
};
